import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';

import { SupportBlock } from '../support-block';
import { useStyles } from './footer.styles';
import { DownloadApp } from './download-app';
import { PolicyLinks } from '../policy-links';
import logo from '../../../assets/images/logo/logo-light.svg';
import { ExternalLinks } from '../../../constants';
import { useLocation } from 'react-router-dom';
import { InternalLinks } from '../../../constants';

export const Footer = ({ legal }: { legal?: string }): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xl'));
  const location = useLocation();
  const isSimulatorPage = location.pathname === `/${InternalLinks.simulatorAom1d}`;
  const hideCampaignsAndDisclaimer =
  location.pathname === '/registration-guide' ||
  location.pathname === '/registration-guide-new';

  return (
    <footer className={classes.footer} data-testid="footer">
      <div className={classes.inner}>
        {isSimulatorPage && (
          <div>
            <p className={classes.disclaimer}>
              {intl.formatMessage(
                { id: 'footer.simulator.disclaimer' },
                { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
              )}
            </p>
            <p className={classes.disclaimer}>
              <FormattedMessage id="footer.simulator.disclaimer.2" />
            </p>
            <div className={classes.separator} data-testid="separator" />
          </div>
        )}
        <div className={classes.logoGroup}>
          <div className={classes.logoWrapper} aria-hidden="true">
            <img src={logo} alt="" width="64" height="65" />
          </div>
          {!isMobile && (
            <div className={classes.policy}>
              <PolicyLinks />
            </div>
          )}
        </div>
        <div className={classes.supportContainer}>
          <SupportBlock />
        </div>
        {isMobile && (
          <div className={classes.policy}>
            <PolicyLinks />
          </div>
        )}
        <DownloadApp />
{!hideCampaignsAndDisclaimer && (
  <>
    <div className={classes.separator} data-testid="separator" />
    <div className={classes.legal}>
      <p>
        <span>
          {intl.formatMessage(
            { id: 'footer.disclaimer' },
            {
              sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              nonBreakSpace: <>&nbsp;</>,
            },
          )}
        </span>
      </p>
      {(location?.pathname === '/' || isSimulatorPage) && (
        <p className={classes.simulator}>
          {intl.formatMessage(
            { id: 'footer.disclaimer.2' },
            {
              sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              a: (chunks: ReactNode) => (
                <a href={ExternalLinks.myAcuvueProgramPolicyLink} className={classes.link}>
                  {chunks}
                </a>
              ),
            },
          )}
        </p>
      )}
    </div>
  </>
)}

<div className={classes.legal}>
  <p>
    {intl.formatMessage(
      {
        id:
          location.pathname === '/registration-guide'
            ? 'footer.terms.reg-guide'
            : location.pathname === '/registration-guide-new'
              ? 'footer.terms.reg-guide-new'
              : 'footer.terms',
      },
      {
        sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
        a: (chunks: ReactNode) => (
          <a href={ExternalLinks.myAcuvueProgramPolicyLink} className={classes.link}>
            {chunks}
          </a>
        ),
      },
    )}
    {legal && intl.formatMessage({ id: legal })}
  </p>
</div>
      </div>
    </footer>
  );
};
